var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90625 0.375C4.59631 0.375 4.27688 0.484844 4.05244 0.709281C3.82859 0.933125 3.71875 1.25256 3.71875 1.5625V2.15625H0.15625V3.34375H0.75V12.8438C0.75 13.8205 1.55453 14.625 2.53125 14.625H9.65625C10.633 14.625 11.4375 13.8205 11.4375 12.8438V3.34375H12.0312V2.15625H8.46875V1.5625C8.46875 1.25256 8.35891 0.933125 8.13447 0.708687C7.91062 0.485437 7.59178 0.375 7.28125 0.375H4.90625ZM4.90625 1.5625H7.28125V2.15625H4.90625V1.5625ZM1.9375 3.34375H10.25V12.8438C10.25 13.1733 9.98578 13.4375 9.65625 13.4375H2.53125C2.20172 13.4375 1.9375 13.1733 1.9375 12.8438V3.34375ZM3.125 5.125V11.6562H4.3125V5.125H3.125ZM5.5 5.125V11.6562H6.6875V5.125H5.5ZM7.875 5.125V11.6562H9.0625V5.125H7.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.3b25c0c1.svg";
export { ForwardRef as ReactComponent };